import { DecorativeBgComponent } from 'signup-components/types';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from 'signup-constants/signupData/Data';
import { getCurrentStepNumbering } from '../flow-management/stepNumberingSelectors';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { getSignupDataValue, isSignupDataCompleted } from '../store/signup-data/selectors';
import { getStepConfig } from '../views/getStepConfig';
import { ExperimentKeys } from './ExperimentKeys';
import { ExperimentParameterGroup } from './ExperimentParameterGroup';
export const getTotalSteps = state => {
  const {
    totalSteps
  } = getCurrentStepNumbering(state);
  const isCompanySizeStepDataCompleted = isSignupDataCompleted(state, Data.CompanySize);
  const isACQ0143Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0143, [ExperimentParameterGroup.Variant_A]);
  const isACQ0145Variant = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  const hasSubmittedCompanySizeOne = getSignupDataValue(state, Data.CompanySize) === CompanySizeOption.One && isCompanySizeStepDataCompleted;
  let additionalTotalSteps = 0;
  if (isACQ0143Variant) {
    // there are 4 or 5 setup steps displayed after signup
    // for company size one, the invite step is not shown during setup
    additionalTotalSteps = hasSubmittedCompanySizeOne ? 4 : 5;
  }
  if (isACQ0145Variant) {
    additionalTotalSteps = 5;
  }
  return totalSteps + additionalTotalSteps;
};
export const getDecorativeBgComponent = ({
  currentStep,
  activeLoading,
  activeError
}) => {
  const stepConfig = getStepConfig(currentStep);
  if (activeLoading || activeError || !stepConfig) {
    return undefined;
  }
  if (stepConfig.shouldUseBgCirclesIfInAcq143) {
    return DecorativeBgComponent.Circles;
  }
  return;
};